(function () {
  function initGrowingEdgesCards(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-gec-section]');

    sections.forEach(function (section) {
      var cards = section.querySelectorAll('[data-card]');
      if (!cards.length) return;

      cards.forEach(function (card) {
        card.addEventListener('touchstart', function () {
          cards.forEach(function (item) {
            if (item !== card) item.classList.remove('is-hovered');
          });
          card.classList.add('is-hovered');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGrowingEdgesCards(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initGrowingEdgesCards(event.target);
  });
})();
